import styled from 'styled-components';

const AbsoluteWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  `;

export default AbsoluteWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/PhoneAbsoluteWrapper.jsx